/**
 * The "powered with air" line of the 2026 splash design ("Air attribution" in
 * the Figma frame). The line is part of the design, so it shows on every
 * product until a scene gives its own text. A user who clears both parts
 * removes the line.
 */
export const POWERED_WITH = "powered with";
export const AIR_MARK = "air";

/** A text field of the edits state: a banner's own value under its id, the shared value under `main`. */
export type TextField = Partial<Record<string, string>>;

/**
 * The text of one part of the line: the banner's own text, else the shared
 * text, else the design's text. An empty string is no text. A part that the
 * user clears holds a zero-width space: the editor and the scene loader store
 * an empty text that way (libs/editableText), so a cleared part stays empty.
 */
export function attributionPart(field: TextField, id: string, designText: string): string {
  return field[id] || field.main || designText;
}
